module.exports = {"application":{"version":"2.21.10","staging":"-pre-prod-"},"bugsnag":{"apiKey":"d44d59f4cc5511ed74b0e9a62522499a"}}